module.exports = __webpack_public_path__ + "img/IntegrationEngine.435c068c.jpg";